'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../index');

var _reactSlidedown = require('react-slidedown');

var _TreeNodeWithChildren = require('./TreeNodeWithChildren');

var _TreeNodeWithChildren2 = _interopRequireDefault(_TreeNodeWithChildren);

var _domHelper = require('../utils/domHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TreeNode = function (_PureComponent) {
  _inherits(TreeNode, _PureComponent);

  function TreeNode(props) {
    _classCallCheck(this, TreeNode);

    var _this = _possibleConstructorReturn(this, (TreeNode.__proto__ || Object.getPrototypeOf(TreeNode)).call(this, props));

    _this.state = {
      selectedValue: ''
    };
    return _this;
  }

  _createClass(TreeNode, [{
    key: 'onCheck',
    value: function onCheck(e) {
      if (this.props.onCheck) {
        this.props.onCheck({
          value: this.props.value,
          children: this.props.rawChildren
        });
      }
    }
  }, {
    key: 'isInteractive',
    value: function isInteractive() {
      return this.props.onExpand && !this.props.disabled && !this.props.expandDisabled && this.hasChildren();
    }
  }, {
    key: 'onSelect',
    value: function onSelect(e) {
      if (this.isInteractive() && !(0, _domHelper.matches)(e.target, ".a-checkbox-input")) {
        this.props.onExpand({
          value: this.props.value
        });
      }

      this.props.onSelect({ value: this.props.value });
    }
  }, {
    key: 'renderCollapseButton',
    value: function renderCollapseButton() {
      var _props = this.props,
          expandDisabled = _props.expandDisabled,
          disabled = _props.disabled;


      if (!this.hasChildren()) {
        return null;
      }

      var cn = (0, _classnames2.default)("a-tree-node-collapse-btn", {
        "disabled": expandDisabled || disabled
      });

      return _react2.default.createElement(
        'div',
        {
          className: cn
        },
        this.renderCollapseIcon()
      );
    }
  }, {
    key: 'renderCollapseIcon',
    value: function renderCollapseIcon() {
      var collapseIcons = this.props.collapseIcons;

      if (!this.props.expanded) {
        if (collapseIcons && collapseIcons.length > 0) {
          return collapseIcons[0];
        } else {
          return _react2.default.createElement('span', { className: 'a-icon a-icon-closed appkiticon icon-plus-outline' });
        }
      } else {
        if (collapseIcons && collapseIcons.length > 1) {
          return collapseIcons[1];
        } else {
          return _react2.default.createElement('span', { className: 'a-icon a-icon-opened appkiticon icon-minus-outline' });
        }
      }
    }
  }, {
    key: 'renderNodeIcon',
    value: function renderNodeIcon() {
      var result = void 0;
      if (this.props.showNodeIcon) {
        if (this.props.icon !== null) {
          result = _react2.default.createElement(
            'span',
            { className: 'a-tree-node-icon' },
            this.props.icon
          );
        } else if (!this.hasChildren()) {
          result = _react2.default.createElement(
            'span',
            { className: 'a-tree-node-icon' },
            _react2.default.createElement('span', { className: 'a-icon appkiticon icon-file-outline' })
          );
        }
      }
      return result;
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      var label = this.props.label;


      return _react2.default.createElement(
        'div',
        { className: 'a-tree-node-title' },
        label
      );
    }
  }, {
    key: 'hasChildren',
    value: function hasChildren() {
      return this.props.rawChildren !== null;
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      if (!this.props.expanded) {
        return _react2.default.createElement(_reactSlidedown.SlideDown, { transitionOnAppear: false });
      } else {
        return _react2.default.createElement(
          _reactSlidedown.SlideDown,
          { transitionOnAppear: false },
          this.props.children
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          style = _props2.style,
          checked = _props2.checked,
          disabled = _props2.disabled,
          keyboardHighlight = _props2.keyboardHighlight,
          _props2$showCheckbox = _props2.showCheckbox,
          showCheckbox = _props2$showCheckbox === undefined ? false : _props2$showCheckbox,
          expandDisabled = _props2.expandDisabled;


      var hasChildren = this.hasChildren();

      var totalNodeCn = (0, _classnames2.default)("a-tree-node", className, {
        "is-folder": hasChildren,
        "is-file": !hasChildren,
        disabled: disabled,
        'selected': this.props.selectedValue === this.props.value
      });
      var checkbox = showCheckbox && _react2.default.createElement(_index.NoClickOutsideCheckbox, { className: 'a-tree-node-checkbox',
        tabIndex: -1,
        onChange: this.onCheck.bind(this),
        disabled: disabled,
        checked: checked });
      var icon = this.renderCollapseButton() || this.renderNodeIcon();

      var nodeCn = (0, _classnames2.default)("a-tree-single-node", className, {
        "is-folder": hasChildren,
        "is-file": !hasChildren,
        "keyboardHighlight": keyboardHighlight,
        disabled: disabled,
        expandDisabled: expandDisabled,
        'selected': this.props.selectedValue === this.props.value
      });

      return _react2.default.createElement(
        'div',
        { className: totalNodeCn, style: style },
        _react2.default.createElement(
          'div',
          { className: nodeCn, onClick: this.onSelect.bind(this) },
          checkbox,
          icon,
          this.renderLabel()
        ),
        this.renderChildren()
      );
    }
  }]);

  return TreeNode;
}(_react.PureComponent);

TreeNode.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  checked: _propTypes2.default.bool,
  children: _propTypes2.default.any,
  rawChildren: _propTypes2.default.arrayOf(_TreeNodeWithChildren2.default),

  label: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  expanded: _propTypes2.default.bool,
  expandDisabled: _propTypes2.default.bool,
  showNodeIcon: _propTypes2.default.bool,
  showCheckbox: _propTypes2.default.bool,
  icon: _propTypes2.default.any,
  collapseIcons: _propTypes2.default.any,

  //event
  onCheck: _propTypes2.default.func,
  onExpand: _propTypes2.default.func,

  value: _propTypes2.default.string
};

TreeNode.displayName = 'TreeNode';

exports.default = TreeNode;